export default __webpack_public_path__ + "static/media/up.eaffd54b.png";